function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.875 26.4219H17.875V13.9062H1.375V2.78125H23.375C24.8337 2.78125 26.2326 3.36729 27.2641 4.41046C28.2955 5.45364 28.875 6.86848 28.875 8.34375V26.4219Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 26.4219H33",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.875 62.5781H17.875V75.0938H1.375V86.2188H23.375C24.8337 86.2188 26.2326 85.6327 27.2641 84.5895C28.2955 83.5464 28.875 82.1315 28.875 80.6562V62.5781Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 62.5781H33",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.375 52.8438C27.9313 52.8438 31.625 49.1081 31.625 44.5C31.625 39.8919 27.9313 36.1562 23.375 36.1562C18.8187 36.1562 15.125 39.8919 15.125 44.5C15.125 49.1081 18.8187 52.8438 23.375 52.8438Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.38 57.0156C15.0553 55.8769 13.0947 54.099 11.7229 51.8854C10.351 49.6719 9.62347 47.1124 9.62347 44.5C9.62347 41.8876 10.351 39.3281 11.7229 37.1146C13.0947 34.901 15.0553 33.1231 17.38 31.9844",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M29.37 31.9844C31.6947 33.1231 33.6553 34.901 35.0271 37.1146C36.3989 39.3281 37.1265 41.8876 37.1265 44.5C37.1265 47.1124 36.3989 49.6719 35.0271 51.8854C33.6553 54.099 31.6947 55.8769 29.37 57.0156",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M64.625 7.09165V16.5479C64.6162 17.1241 64.4895 17.6921 64.2528 18.2163C64.0162 18.7404 63.6747 19.2093 63.25 19.5934C61.3498 21.2839 58.9058 22.2164 56.375 22.2164C53.8442 22.2164 51.4002 21.2839 49.5 19.5934C49.0753 19.2093 48.7339 18.7404 48.4972 18.2163C48.2605 17.6921 48.1338 17.1241 48.125 16.5479V7.07774C48.1289 6.50278 48.2535 5.93522 48.4905 5.41261C48.7276 4.88999 49.0717 4.42425 49.5 4.04619C51.3962 2.34723 53.8417 1.40918 56.375 1.40918C58.9083 1.40918 61.3539 2.34723 63.25 4.04619C63.6747 4.43026 64.0162 4.89915 64.2528 5.4233C64.4895 5.94745 64.6162 6.51551 64.625 7.09165V7.09165Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M44 9.73438H64.625",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M35.75 48.6719H53.2538C53.8447 48.6737 54.4302 48.5573 54.9765 48.3295C55.5229 48.1016 56.0193 47.7667 56.4371 47.3441C56.855 46.9215 57.1861 46.4194 57.4115 45.8669C57.6368 45.3144 57.7518 44.7222 57.75 44.1245V30.5938",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M35.75 38.9375H48.125V27.8125C48.125 25.5041 51.5075 22.25 55.6875 22.25C59.8675 22.25 63.25 25.5041 63.25 27.8125V86.2188C63.25 86.5876 63.1051 86.9413 62.8473 87.2021C62.5894 87.4629 62.2397 87.6094 61.875 87.6094H39.875V84.258C39.875 83.3027 40.2502 82.3866 40.9181 81.7112C41.5859 81.0357 42.4917 80.6562 43.4362 80.6562H48.125V48.6719",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M63.25 51.4531L56.375 87.6094",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 89,
    viewBox: "0 0 66 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.e97f171f.svg";
export { ForwardRef as ReactComponent };